import { Box } from '@mui/material';
import BasicModal from 'components/Common/BasicModal';
import { Message } from 'components/JobGenerator/types';
import Output from 'components/Output';
import { FC } from 'react';
import { JobParamsType } from 'store/auth/types';
import { SelectedLanguageType } from 'store/global/types';

interface FullScreenModalType {
    open: boolean;
    onClose: () => void;
    messages?: Message[];
    regenerate?: (
        languages: SelectedLanguageType[],
        prev_message_id: string | null,
        params?: JobParamsType,
    ) => void;
    isGeneratingJob?: boolean;
    item: Message;
}

const FullScreenModal: FC<FullScreenModalType> = ({
    open,
    onClose,
    messages,
    isGeneratingJob,
    regenerate,
    item,
}) => {
    return (
        <BasicModal open={open} onClose={onClose}>
            <Box className="fullScreen-job">
                <Box className="job-generator">
                    <Output
                        item={item}
                        isFullScreenMode
                        messages={messages}
                        isGeneratingJob={isGeneratingJob}
                        regenerate={regenerate}
                        onCloseParentFullScreen={onClose}
                        hiddenMessages={[]}
                    />
                </Box>
            </Box>
        </BasicModal>
    );
};

export default FullScreenModal;
